import * as React from 'react';
import { StyleSheet, css } from 'aphrodite';
import {
    Grid,
    TextField,
    Button,
    LinearProgress,
    Switch,
    FormControlLabel,
    InputLabel,
    FormGroup, Chip
} from "@material-ui/core";
import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker,
    KeyboardDatePicker,
} from '@material-ui/pickers';

interface ClassDetailsFormProps {
    onSave: () => void;
    onPreviewBeginningPressed: () => void;
    onOptimizePressed: () => void;
    onFieldChange: (key: string, value: any) => void;
    data: any;
    errors: any;
    isSaving: boolean;
}

const ClassDetailsForm : React.FC<ClassDetailsFormProps> = (props) => {

    return(
        <form noValidate autoComplete="off">

            <FormGroup row={true}>
                <FormControlLabel
                    className={css(styles.switch)}
                    control={
                        <Switch
                            disabled={(props.data.replayUrl && props.data.teacherId) ? false : !props.data.availableForReplay }
                            checked={props.data.availableForReplay || false}
                            onChange={(event: any) => props.onFieldChange('availableForReplay', event.target.checked)}
                            color="primary"
                        />
                    }
                    label="Available for Replay"
                />
            </FormGroup>


            <FormGroup row={true} className={css(styles.optimizedFormGroup)}>
                <InputLabel className={css(styles.optimizedLabel)}>
                    Optimized for Replay
                </InputLabel>
                <Chip className={css(styles.formGroupElement)}
                    color={props.data.replayUrl ? "primary" : "secondary" }
                    label={props.data.replayUrl ? "yes" : "no" }
                />
                <Button
                    className={css(styles.optimizeButton)}
                    color={"primary"}
                    variant="contained"
                    onClick={props.onOptimizePressed}>
                        Optimize
                </Button>
                <InputLabel className={css(styles.optimizedLabel)}>
                    Teacher Id Set
                </InputLabel>
                <Chip className={css(styles.formGroupElement)}
                      color={props.data.teacherId ? "primary" : "secondary" }
                      label={props.data.teacherId ? "yes" : "no" }
                />
            </FormGroup>

            <TextField
                className={css(styles.textField)}
                label="Replay Title"
                variant="outlined"
                multiline rows={2}
                value={props.data.replayTitle}
                required={true}
                onChange={(event) => props.onFieldChange('replayTitle', event.target.value)}
            />

            <TextField
                label="Replay Description"
                className={css(styles.textField)}
                multiline
                value={props.data.replayDescription}
                onChange={(event) => props.onFieldChange('replayDescription', event.target.value)}
                rows={4}
                variant="outlined"
            />

            <TextField
                className={css(styles.textField)}
                label="Replay Start Time"
                variant="outlined"
                error={props.errors.replayStartTime}
                helperText="Format: m:ss Examples: 0:01, 1:10, 11:00"
                value={props.data.replayStartTime}
                onChange={ event => props.onFieldChange('replayStartTime', event.target.value)}
            />
            <TextField
                className={css(styles.textField)}
                label="Replay End Time"
                variant="outlined"
                error={props.errors.replayEndTime}
                helperText="Format: m:ss Examples: 0:01, 1:10, 11:00"
                value={props.data.replayEndTime}
                onChange={ event => props.onFieldChange('replayEndTime', event.target.value)}
            />

            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justify="space-around">
                    <KeyboardDatePicker
                        margin="normal"
                        id="date-picker-dialog"
                        label="Date First Aired"
                        value={props.data.dateFirstAired}
                        onChange={event => props.onFieldChange('dateFirstAired', event)}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                    />
                    <KeyboardTimePicker
                        margin="normal"
                        id="time-picker"
                        label="Date First Aired"
                        value={props.data.dateFirstAired}
                        onChange={event => props.onFieldChange('dateFirstAired', event)}
                        KeyboardButtonProps={{
                            'aria-label': 'change time',
                        }}
                    />
                </Grid>
            </MuiPickersUtilsProvider>

            <TextField
                className={css(styles.textField)}
                label="Theme"
                variant="outlined"
                value={props.data.theme}
                onChange={ event => props.onFieldChange('theme', event.target.value)}
            />

            <TextField
                className={css(styles.textField)}
                label="Displayed Duration Mins"
                variant="outlined"
                value={props.data.displayedDurationMins}
                onChange={ event => props.onFieldChange('displayedDurationMins', event.target.value)}
            />

            <TextField
                className={css(styles.textField)}
                label="Cover Image Url"
                variant="outlined"
                value={props.data.coverImageUrl}
                onChange={ event => props.onFieldChange('coverImageUrl', event.target.value)}
            />

            { props.isSaving && <LinearProgress /> }

            <div className={css(styles.buttonContainer)}>
                <Button
                    variant="contained"  className={css(styles.formGroupElement)}
                    onClick={props.onPreviewBeginningPressed}
                >
                    Preview Beginning
                </Button>

                <Button
                    variant="contained" color={"secondary"}
                    className={css(styles.formGroupElement)}
                    onClick={props.onSave}
                    disabled={props.isSaving}
                >
                    {props.isSaving ? 'Saving...' : 'Save'}
                </Button>
            </div>

        </form>
    );
};

const styles = StyleSheet.create({
    textField: {
        width: "100%",
        marginBottom: "10px"
    },
    switch: {
        float: "left",
        marginBottom: "10px"
    },
    buttonContainer: {
        marginTop: "10px",
        marginBottom: "40px"
    },
    formGroupElement: {
        marginRight: "10px"
    },
    optimizedFormGroup: {
        marginTop: "15px",
        marginBottom: "30px"
    },
    optimizedLabel: {
        marginTop: '10px',
        marginRight: '10px'
    },
    optimizeButton: {
        marginRight: '10px'
    }
});


export default ClassDetailsForm;


// WEBPACK FOOTER //
// ./src/components/replay/classes/ClassDetailsForm.tsx